var Organization = /** @class */ (function () {
    function Organization(_a) {
        var _this = this;
        var id = _a.id, name = _a.name;
        this.toJSON = function () { return ({
            id: _this.id,
            name: _this.name,
        }); };
        this.id = id;
        this.name = name;
    }
    Organization.fromJSON = function (json) {
        var _a = Object.assign({}, json), id = _a.id, name = _a.name;
        if (typeof id !== 'string')
            throw new Error('id must be a string');
        if (typeof name !== 'string')
            throw new Error('name must be a string');
        return new Organization({
            id: id,
            name: name,
        });
    };
    return Organization;
}());
export default Organization;
